import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageBox } from '../../components/pageBox';
import { KanbanBoardContent } from '../../components/kanban/KanbanBoardContent';

export const KanbanBoardPage = () => {
  const { itemId } = useParams<{ itemId: string }>();
  const navigate = useNavigate();

  const numericProjectId = itemId ? parseInt(itemId, 10) : 0;

  return (
    <PageBox>
      <KanbanBoardContent projetoId={numericProjectId} onBack={() => navigate('/kanban')} />
    </PageBox>
  );
};
